import React, {Component} from 'react';
import classNames from 'classnames';
import TableData from '../../utils/tableUtil'

class PortfolioAccountClasifcation extends Component {

  constructor(props){
    super(props);
    this.state={data:props.data}
  }

  render() {
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    });

    let headers = this.props.data.map(info => {
      return <th>{info.type}</th>
    });

    let rows = this.props.data.map( info => {
      return <TableData content={info.quantity}/>
    });

    return(
      <table className={tableClass}>
        <thead>
        <tr>
          {headers}
        </tr>
        </thead>
        <tbody>
        <tr>
          {rows}
        </tr>
        </tbody>
      </table>
    );

  }
}

export default PortfolioAccountClasifcation;



// WEBPACK FOOTER //
// ./src/components/tables/portfolioAccountClasification.js